// extracted by mini-css-extract-plugin
export default {"content":"Entries_content__7rML+"};